export const CHART_TAIL_TYPES = {
  BOTH: 'both', LEFT: 'left', RIGHT: 'right', CENTER: 'center', EQUAL: 'equal'
};
